import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';
import { ACHIEVEMENT_ACTIONS } from '../../../../constants/achievements';

const propTypes = {
  achievementLevel: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    achievement: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
};

const PendingAchievement = ({ achievementLevel, className }) => {
  const classes = classNames({
    'achievement-pending': true,
    [className]: !!classNames,
  });

  return (
    <div className={classes}>
      <div className="achievement-pending-header">
        <img
          width="22px"
          src={getAsset(
            achievementLevel.achievement.action ===
              ACHIEVEMENT_ACTIONS.SHUTTERBUG_PHOTO_UPLOAD
              ? '/storage-white.svg'
              : '/gift-white.svg',
          )}
          alt="Unlockable achievement"
        />
        <p className="achievement-pending-name">
          {achievementLevel.achievement.name}
        </p>
      </div>
      <div>
        <p className="my-0">{achievementLevel.description}</p>
      </div>
    </div>
  );
};

PendingAchievement.propTypes = propTypes;

export default PendingAchievement;
